<template>
  <div class="authority-dialog">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :show-footer="false"
      :has-form="true"
      :title="'授权:'+ form.name"
      class="authority-dialog-modal"
      width="50%"
      top="5%"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >

      <div class="page-form">
        <gs-form
          ref="form"
          :model="form"
          class="form"
          label-width="95px"
          label-position="left"
          gap="small"
        >
          <gs-form-item
            label="设备/对象"
            prop="device"
            class="form-item-device"
          >
            <gs-input
              v-model="form.name"
              :disabled="disabled"
              type="text"
              placeholder="请输入用户描述"
            />
          </gs-form-item>

          <!-- <gs-form-item
            label="数据库拥有者"
            prop="databaseOwner"
            class="form-item-databaseOwner"
          >
            <gs-input
              v-model="form.device"
              :disabled="disabled"
              type="text"
              placeholder="请输入用户描述"
              style="width: 50%"
            />
            <gs-button @click="getOwnership">获得所有权</gs-button>
          </gs-form-item> -->

          <!-- <div class="checkbox">
            <div><gs-checkbox>Require signature on database object change</gs-checkbox></div>
            <div><gs-checkbox>Protected database object</gs-checkbox></div>
          </div> -->

          <gs-form-item
            label="访问控制列表"
            prop="accessControlList"
            style="margin-bottom: 0px"
          />

          <div class="form-item-accessControlList">
            <gs-table
              ref="clearSelection"
              :data="tableData"
              style="width: 100%"
              @select="getSelection"
              @select-all="getSelection"
            >
              <gs-table-column
                type="selection"
                fixed
              />
              <gs-table-column
                :show-overflow-tooltip="true"
                prop="label"
                label="用户组/用户"
              />
              <gs-table-column
                :show-overflow-tooltip="true"
                prop="accessLevel"
                label="权限"
              />
            </gs-table>
          </div>

          <gs-form-item
            label="访问级别"
            prop="accessLevel"
            style="margin-bottom: 0px"
          />
          <div class="form-item-accessLevel">
            <div class="form-item-accessLevel-select">
              <gs-select
                v-model="form.accessLevel"
                @change="changeAccessLevel"
              >
                <gs-option
                  label="禁止"
                  value="NO_ACCESS"
                />
                <gs-option
                  label="只读"
                  value="READ"
                />
                <gs-option
                  label="读写"
                  value="READ_WRITE"
                />
                <gs-option
                  label="Change"
                  value="CHANGE"
                />
                <gs-option
                  label="全权"
                  value="FULL_CONTROL"
                />
              </gs-select>
            </div>
            <div class="form-item-accessLevel-checkbox">
              <!--<gs-checkbox v-model="isOnSubunits">更改子单元上的访问级别</gs-checkbox>-->
              <el-checkbox v-model="isOnSubunits">更改子单元上的访问级别</el-checkbox>
            </div>
          </div>
          <gs-form-item
            label="用户组/用户"
            prop="groupsOrUsers"
            style="margin-bottom: 0px"
          />
          <div class="form-item-groupsOrUsers">
            <gs-tree
              ref="tree"
              :data="treeData"
              show-checkbox
            />
          </div>
          <div class="button">
            <gs-form-item style="float: right">
              <gs-button @click="addToList">添加</gs-button>
              <gs-button @click="removeFromList">删除</gs-button>
            </gs-form-item>
            <gs-form-item>
              <gs-button
                type="primary"
                @click="handleConfirm(1)"
              >确定</gs-button>
              <gs-button @click="close">取消</gs-button>
              <gs-button @click="handleConfirm">应用</gs-button>
            </gs-form-item>
          </div>
        </gs-form>
      </div>
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/authorityService.js'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data () {
    return {
      isOnSubunits: true,
      disabled: true,
      startTableData: [], // 初始的访问控制列表
      selection: [], // 选中用户组/用户的集合
      form: {
        name: '',
        id: '',
        type: '',
        accessLevel: 'READ'
      },
      tableData: [],
      treeData: [{
        label: '用户组',
        children: []
      }, {
        label: '用户',
        children: []
      }],
      upserts: {
        users: [],
        groups: []
      },
      dels: {
        users: [],
        groups: []
      }
    }
  },
  computed: {
    ...mapState({
      visible: 'authorityShow',
      objectData: 'objectInfo',
      nodeData: 'nodeTree'
    })
  },
  watch: {
    visible () {
      if (this.visible) {
        if (JSON.stringify(this.objectData) !== '{}') {
          this.form = this.objectData
          this.form.accessLevel = 'READ'
          this.disabled = true
          if (this.form.type === 'user') {
            this.form.resourceType = 'user'
          } else if (this.form.type === 'group') {
            this.form.resourceType = 'group'
          } else {
            this.form.resourceType = 'device'
          }
        }
        // 每次打开授权界面都会重新刷新一次用户组/用户的树
        this.treeData = [{
          label: '用户组',
          children: []
        }, {
          label: '用户',
          children: []
        }]
        service.getGroupAndUserList().then(res => {
          res.forEach((value, index, array) => {
            value.label = value.groupName // 增加展示树节点需要的label属性
            value.children = value.users // 增加树节点下的子节点属性children
            value.children.forEach((value, index, array) => {
              value.label = value.username // 增加展示子节点需要的label属性
            })
          })
          this.treeData[0].children = res // 将用户组增加到用户组节点下
        })
        service.getAllUserList(localStorage.getItem("userId")).then(res => {
          res.forEach((value, index, array) => {
            value.label = value.username // 增加展示树节点需要的label属性
          })
          this.treeData[1].children = res // 将用户增加到用户节点下
        })
        // 获取拥有资源的用户\用户组列表
        this.tableData = []
        this.startTableData = []
        let id = ''
        switch (this.form.resourceType) {
          case 'device':
            id = this.form.id
            break
          case 'user':
            id = this.form.userId
            break
          case 'group':
            console.log(this.form)
            id = this.form.groupId
            break
          default:
            break
        }
        service.getResourcesOwners(this.form.resourceType, id).then(res => {
          res.users.forEach((value, index, array) => {
            value.label = value.username
          })
          res.groups.forEach((value, index, array) => {
            value.label = value.groupName
          })
          this.tableData = res.groups.concat(res.users)
          this.tableData.forEach((value, index, array) => {
            let {...obj} = value
            this.startTableData.push(obj)
          })
        })
        this.isOnSubunits = true
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapMutations({
      close: 'AUTHORITY_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    beforeClose (e, done) {
      this.close()
    },
    beforeConfirm (e, done) {
      done()
    },
    handleConfirm (input) {
      // alert('修改前' + JSON.stringify(this.startTableData))
      // alert('修改后' + JSON.stringify(this.tableData))
      this.upserts.users = []
      this.upserts.groups = []
      this.dels.users = []
      this.dels.groups = []
      if (this.startTableData === null || this.startTableData.length === 0) {
        this.tableData.forEach((value, index, array) => {
          if (value.userId) {
            this.upserts.users.push({
              'ownerId': value.userId,
              'accessLevel': value.accessLevel
            })
          }
          if (value.groupId) {
            this.upserts.groups.push({
              'ownerId': value.groupId,
              'accessLevel': value.accessLevel
            })
          }
        })
      } else {
        // 对比修改后和修改前的访问控制列表,如果在修改前列表里面找不到的即添加到upserts中
        if (this.isOnSubunits) {
          this.tableData.forEach(res => {
            if (res.userId !== undefined) {
              this.upserts.users.push({
                'ownerId': res.userId,
                'accessLevel': res.accessLevel
              })
            }
            if (res.groupId !== undefined) {
              this.upserts.groups.push({
                'ownerId': res.groupId,
                'accessLevel': res.accessLevel
              })
            }
          })
        } else {
          for (let i = 0; i < this.tableData.length; i++) {
            let flag = false
            for (let j = 0; j < this.startTableData.length; j++) {
              if (this.tableData[i].userId !== undefined && this.startTableData[j].userId !== undefined && this.tableData[i].userId === this.startTableData[j].userId) {
                if (this.tableData[i].accessLevel === this.startTableData[j].accessLevel) {
                  flag = true
                  break
                }
              }
              if (this.tableData[i].groupId !== undefined && this.startTableData[j].groupId !== undefined && this.tableData[i].groupId === this.startTableData[j].groupId) {
                if (this.tableData[i].accessLevel === this.startTableData[j].accessLevel) {
                  flag = true
                  break
                }
              }
            }
            if (!flag) {
              if (this.tableData[i].userId !== undefined) {
                this.upserts.users.push({
                  'ownerId': this.tableData[i].userId,
                  'accessLevel': this.tableData[i].accessLevel
                })
              }
              if (this.tableData[i].groupId !== undefined) {
                this.upserts.groups.push({
                  'ownerId': this.tableData[i].groupId,
                  'accessLevel': this.tableData[i].accessLevel
                })
              }
            }
          }
        }

        // 对比修改前和修改后的访问控制列表,如果在修改后列表里面找不到的即添加到dels中
        for (let i = 0; i < this.startTableData.length; i++) {
          let flag = false
          for (let j = 0; j < this.tableData.length; j++) {
            if (this.tableData[j].userId !== undefined && this.startTableData[i].userId !== undefined && this.startTableData[i].userId === this.tableData[j].userId) {
              flag = true
              break
            }
            if (this.tableData[j].groupId !== undefined && this.startTableData[i].groupId !== undefined && this.startTableData[i].groupId === this.tableData[j].groupId) {
              flag = true
              break
            }
          }
          if (!flag) {
            if (this.startTableData[i].userId !== undefined) {
              this.dels.users.push({
                'ownerId': this.startTableData[i].userId,
                'accessLevel': this.startTableData[i].accessLevel
              })
            }
            if (this.startTableData[i].groupId !== undefined) {
              this.dels.groups.push({
                'ownerId': this.startTableData[i].groupId,
                'accessLevel': this.startTableData[i].accessLevel
              })
            }
          }
        }
      }
      let params = {
        upserts: this.upserts,
        dels: this.dels,
        isOnSubunits: this.isOnSubunits
      }
      let id = ''
      switch (this.form.resourceType) {
        case 'device':
          id = this.form.id
          break
        case 'user':
          id = this.form.userId
          break
        case 'group':
          id = this.form.groupId
          break
        default:
          break
      }
      service.addResourcesOwners(id, this.form.resourceType, params).then(res => {
        this.$Message.success('授权成功!')
        if (input === 1) {
          this.close()
          this.isOnSubunits = true
        }
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    getOwnership () {
      this.disabled = false
    },
    addToList () {
      let array = this.$refs['tree'].getCheckedNodes()
      if (array === null || array.length === 0) {
        this.$Message.warning('请勾选用户组或用户再进行添加')
        return
      }
      array.forEach((value, index, array) => {
        if (value.$node.level === 2) {
          if (value.data.userId) {
            let flag = false
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].userId && value.data.userId === this.tableData[i].userId) {
                flag = true
                break
              }
            }
            if (!flag) {
              this.tableData.push({
                'userId': value.data.userId,
                'accessLevel': 'READ',
                'label': value.data.label
              })
            }
          } else {
            let flag = false
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].groupId && value.data.groupId === this.tableData[i].groupId) {
                flag = true
                break
              }
            }
            if (!flag) {
              this.tableData.push({
                'groupId': value.data.groupId,
                'accessLevel': 'READ',
                'label': value.data.label
              })
            }
          }
        }
        if (value.$node.level === 3) {
          let parentNode = value.$node.parent
          let flag = false
          for (let i = 0; i < array.length; i++) {
            if (parentNode.data.groupId && array[i].data.groupId && parentNode.data.groupId === array[i].data.groupId) {
              flag = true
              break
            }
          }
          if (!flag) {
            if (value.data.userId) {
              let flag = false
              for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].userId && value.data.userId === this.tableData[i].userId) {
                  flag = true
                  break
                }
              }
              if (!flag) {
                this.tableData.push({
                  'userId': value.data.userId,
                  'accessLevel': 'READ',
                  'label': value.data.label
                })
              }
            } else {
              let flag = false
              for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].groupId && value.data.groupId === this.tableData[i].groupId) {
                  flag = true
                  break
                }
              }
              if (!flag) {
                this.tableData.push({
                  'groupId': value.data.groupId,
                  'accessLevel': 'READ',
                  'label': value.data.label
                })
              }
            }
          }
        }
      })
      array.forEach((value, index, array) => {
        this.$refs['tree'].setChecked(value.$node.key, false)
      })
    },
    removeFromList () {
      if (this.selection != null && this.selection.length > 0) {
        for (let i = 0; i < this.selection.length; i++) {
          for (let j = 0; j < this.tableData.length; j++) {
            if (this.selection[i].userId != null && this.tableData[j].userId != null && this.selection[i].userId === this.tableData[j].userId) {
              this.tableData.splice(j, 1)
              break
            }
            if (this.selection[i].groupId != null && this.tableData[j].groupId != null && this.selection[i].groupId === this.tableData[j].groupId) {
              this.tableData.splice(j, 1)
              break
            }
          }
        }
      }
    },
    getSelection (selection, row) {
      this.selection = selection
      if (this.selection != null && this.selection.length > 0) {
        this.form.accessLevel = this.selection[this.selection.length - 1].accessLevel
      }
    },
    changeAccessLevel (input) {
      this.selection.forEach((value, index, array) => {
        value.accessLevel = input
      })
      this.$refs['clearSelection'].clearSelection(this.selection)
    }
  }
}
</script>
<style lang="scss" scoped>
  .authority-dialog {
    &-modal {
      .page-form {
        .title {
          color: #0073e8;
          margin-bottom: 12px;
        }
        .gs-form-item {
          margin-bottom: 12px;
        }
        .button {
          float: right;
        }
        .checkbox {
          margin-bottom: 12px;
        }
        .form-item-accessControlList {
          height: 150px;
          overflow: auto;
          margin-bottom: 12px;
          padding: 12px;
          border: solid 1px #d9d9d9;
          border-radius: 1px;
        }
        .form-item-accessLevel {
          display: flex;
          &-select {
            width: 40%;
            margin-right: 24px;
          }
        }
        .form-item-groupsOrUsers {
          height: 150px;
          overflow: auto;
          margin-bottom: 12px;
          padding: 12px;
          border: solid 1px #d9d9d9;
          border-radius: 1px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/authority/authority.vue